<template>
  <div class="no-data-wrapper">
    <aha-icon name="no-result" maintain-color />
    <div class="pt-4 font-bold text-base">
      {{ $i18nPresenter.t('couldntFindResultMatch', {
        content: getSearchContent
      }) }}
    </div>
    <div
      class="flex justify-center mt-4"
    >
      <div>
        <!-- desktop new presentation button -->
        <aha-button
          class="inline mr-3"
          size="xl"
          @click="onClickNewPresentation"
        >
          <aha-icon
            name="add"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>{{ $i18nPresenter.t("New Presentation") }}</span>
        </aha-button>
      </div>
      <aha-button
        class="px-2.5 sm:px-4"
        variant="base"
        size="xl"
        @click="request()"
        :disabled="submitting || isComplete"
        :submitting="submitting"
      >
        <span v-if="!isComplete">{{ $i18nPresenter.t("Request") }}</span>
        <span v-else>{{ $i18nPresenter.t("Requested") }}</span>
      </aha-button>
    </div>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'
import utils from '@/util'
import ApiTemplate from '@/api/template'
import CreateNewPresentationMixin from '@/mixins/presentation/CreateNewPresentationMixin'

export default {
  mixins: [CreateNewPresentationMixin],
  props: {
    keyword: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'template',
    },
  },
  data() {
    return {
      newPresentationTrigger: null,
      isComplete: false,
      submitting: false,
    }
  },
  computed: {
    getSearchContent() {
      if (this.keyword && this.keyword.length > 1) {
        return `"${this.keyword}".`
      }
      return this.$i18nPresenter.t('this search.')
    },
  },
  methods: {
    onClickNewPresentation() {
      this.newPresentationTrigger = 'New dropdown menu'
      this.createNewPresentation(this.newPresentationTrigger)
    },
    async request() {
      if (this.submitting) return
      this.submitting = true
      try {
        await ApiTemplate.requestTemplate({
          keyword: this.keyword,
          type: this.type,
        })
        const successMessage = this.$i18nPresenter.t('Thanks for your template request!')
        utils.showToastSuccess(successMessage)
        this.isComplete = true
        this.submitting = false
        this.$emit('request')
        utils.mixpanelTracking(
          'Templates',
          'Templates > Request Template',
          this.keyword,
        )
        const query = {
          from: 'requestTemplate',
        }
        this.$router.push({ name: 'TemplateLibrary', query })
      } catch (error) {
        Sentry.captureException(error)
        this.$emit('request')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.no-data-wrapper {
  @apply text-center relative flex flex-col items-center justify-center;
}
</style>
